import { takeLatest, call, all } from "redux-saga/effects";
import { toast } from "react-toastify";

import jsPdfGenerator from "../../../services/generatePDF";

import api from "../../../services/api";

export function* createPerson({ payload }) {
  try {
    const {
      name,
      birthday,
      status,
      occupation,
      family_count,
      cpf,
      nis,
      contact,
      address,
      neighborhood,
    } = payload;

    const person = {
      name,
      birthday,
      status,
      occupation,
      family_count,
      cpf,
      nis,
      contact,
      address,
      neighborhood,
    };

    const loggedUser = JSON.parse(localStorage.getItem("persist:onfish")).user;
    const createdby = JSON.parse(loggedUser)?.profile.name


    yield call(api.post, "people", person);


    jsPdfGenerator(
      name,
      cpf,
      nis,
      family_count,
      occupation,
      address,
      birthday,
      contact,
      neighborhood,
      status,
      createdby
    );

    toast.success("Pessoa registrada com sucesso!");
  } catch (err) {
    toast.error(err.response.data.message);
  }
}

export function* updatePerson({ payload }) {
  try {
    const {
      name,
      birthday,
      status,
      occupation,
      family_count,
      cpf,
      nis,
      contact,
      address,
      neighborhood,
      createdby,
    } = payload;

    const person = {
      name,
      birthday,
      status,
      occupation,
      family_count,
      cpf,
      nis,
      contact,
      address,
      neighborhood,
      createdby,
    };

    yield call(api.put, `people/${cpf}`, person);

    toast.success("Pessoa atualizada com sucesso!");
  } catch (err) {
    toast.error(err.response.data.message);
  }
}

export default all([
  takeLatest("@person/UPDATE_PERSON_REQUEST", updatePerson),
  takeLatest("@person/CREATE_PERSON_REQUEST", createPerson),
]);
